import { Box } from "@mui/joy";

export default function FacebookPixel() {
  return (
    <Box
      component="img"
      src="https://www.facebook.com/tr?id=1159171955167843&ev=PageView"
      height="1"
      width="1"
      sx={{ display: "none" }}
    />
  );
}
